module.exports={"Clear search":"Keresés törlése"};